/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */
import { Box, CircularProgress, Paper} from '@mui/material';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 500,
  maxHeight: 500,
};

const paperStyle = {
  padding: 5,
  width: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'

};

export default function AcceptTermsAndConditions({size = 30}: {size: number}) {

  return (
    <rotor-loading-indicator size="large"   accent="color-600" />
  );
};
